import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { track } from '../../utils/analytics';
import { AnalyticsEvents } from '../../utils/analyticsEvents';

export function useResetPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { resetPassword } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    try {
      await resetPassword(email);
      track(AnalyticsEvents.PASSWORD_RESET_REQUEST);
      setMessage('If the email exists, a password reset link has been sent.');
    } catch (err: any) {
      setError('Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const clearMessage = () => setMessage('');

  return {
    email,
    setEmail,
    message,
    error,
    loading,
    handleSubmit,
    clearMessage,
    navigate,
  };
}
